import MUIBox, { BoxProps as MUIBoxProps } from '@mui/material/Box';

export type BoxProps<C extends React.ElementType = React.ElementType> = MUIBoxProps<C, { component?: C }>;

export const Box = MUIBox;
